export default {
	TaxReturnSubmissionIsPaidList: {
		TaxReturn: 'Tờ khai',
		MustPaidTaxAmount: 'Số thuế phải nộp',
		PaidTaxAmount: 'Số thuế đã nộp',
		LeftTaxAmount: 'Số thuế còn lại',
		TaxPaymentStatus: 'Tình trạng nộp thuế',
		MisaSentDate: 'Ngày gửi tờ khai',
		TaxPaymentDate: 'Ngày nộp thuế',
		SubmissionId: 'Mã giao dịch',
		TaxCode: 'Mã số thuế/CCCD',
		TaxAgentName: 'Cơ quan thuế',
		AdditionTimes: 'Lần nộp',
		BusinessName: 'Tham chiếu'
	},
	MustPayTaxAmountReport: {
		VNDTotalAmount: 'Số tiền (VND)',
		USDTotalAmount: 'Số tiền (USD)'
	},
	MustPayTaxAmountReportDetail: {
		BankPaymentID: 'Mã CT ngân hàng',
		DecDate: 'Kỳ tính thuế',
		TaxPaperType: 'Loại GNT',
		MoneyType: 'Loại tiền',
		PayerBankName: 'Ngân hàng',
		PlaceHolderSearch: 'Nhập để tìm kiếm',
		PlaceHolderSearchTooltip:
			'Nhập mã giao dịch, mã số thuế, số giấy nộp tiền, mã chứng từ ngân hàng để tìm kiếm'
	}
};
